import { render, staticRenderFns } from "./PrintTagMainView.vue?vue&type=template&id=0b1bb66c&scoped=true"
import script from "./PrintTagMainView.vue?vue&type=script&lang=js"
export * from "./PrintTagMainView.vue?vue&type=script&lang=js"
import style0 from "./PrintTagMainView.vue?vue&type=style&index=0&id=0b1bb66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1bb66c",
  null
  
)

export default component.exports